import {
  ProrodinkiServiceProvider,
  ProrodinkiServiceConsumer
} from './prorodinki-service-context';

export {
  ProrodinkiServiceProvider,
  ProrodinkiServiceConsumer
};
